import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DomSanitizer } from '@angular/platform-browser';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { DocumentManagementService } from 'src/app/services/document-management.service';
import { TranslateService } from '@ngx-translate/core';
import { UrlValidatorService } from 'src/app/services/url-validator.service';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';


@Component({
  selector: 'app-document-management',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.less']
})
export class DocumentsComponent implements OnInit {
  @ViewChild("dropdownRef", { static: false }) dropdownRef!: ElementRef
  @ViewChild("tabList", { static: false }) tabListRef!: ElementRef<HTMLDivElement>

  private destroy$ = new Subject<void>()
  private hideTimeout: any = null
  private resizeObserver?: ResizeObserver


  params = {
    title: '',
    content: '',
    parentId: 0,
  };
  activeTopTab = 0
  activeTopTabMobile = 0
  visibleTabStart = 0
  currentPath: any[] = []
  hoveredTab: number | string = ""
  hoveredFolder: string | null = null
  isMobile = false
  sidebarVisible = true
  pagination = {
    total: 0,
    pageIndex: 1,
    pageSize: 6
  };
  documents: any[] = []
  nodes: any[] = [];

  canScrollLeft = false
  canScrollRight = false
  dropdownPosition: { x: number; y: number } | null = null;
  isDealerPortal: boolean = false;

  menuVisible = false;

  /** 点击任何菜单项／子菜单标题时，都会调用 */
  onSelect(event: MouseEvent,key: number): void {
    event.stopPropagation();
    this.activeTopTabMobile = key;
    console.log("this.activeTopTab",this.activeTopTab)
  }

  /** 控制同级互斥展开，如果需要 */
  onOpenChange(openKeys: any): void {
    // 只保留最后一个打开的 submenu
    this.activeTopTabMobile = openKeys.length ? openKeys[openKeys.length - 1] : 0;
  }

handleLeafClick() {
  if(this.menuVisible && this.activeTopTabMobile){
    this.activeTopTab = this.activeTopTabMobile;
    this.currentPath = this.findPathById(this.nodes, this.activeTopTab)
    this.params.parentId = this.activeTopTab;
    this.onSearch()
  }
  this.menuVisible = !this.menuVisible;
}


  ngAfterViewInit() {
    this.checkScrollState()
    this.setupResizeObserver()
    this.setupScrollListener()
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    window.removeEventListener("resize", () => this.checkScreenSize())
    document.removeEventListener("click", (event) => this.handleClickOutside(event))
  }

  private setupResizeObserver() {
    if (typeof ResizeObserver !== "undefined" && !this.isMobile) {
      this.resizeObserver = new ResizeObserver(() => {
        this.checkScrollState()
      })
      this.resizeObserver.observe(this.tabListRef.nativeElement)
    }
  }

  private setupScrollListener() {
    if(!this.isMobile){
      this.tabListRef.nativeElement.addEventListener("scroll", () => {
        this.checkScrollState()
      })
    }
  }

  getDropdownPosition(tabId: any): number {
    if (!this.tabListRef?.nativeElement) return 0;

    const buttons = this.tabListRef.nativeElement.children;
    const tabIndex = this.nodes.findIndex(node => node.id === tabId);

    if (tabIndex === -1 || !buttons[tabIndex]) return 0;

    const button = buttons[tabIndex] as HTMLElement;
    return button.offsetLeft;
  }

  checkScrollState() {
    if (this.tabListRef?.nativeElement) {
      const { scrollLeft, scrollWidth, clientWidth } = this.tabListRef.nativeElement
      this.canScrollLeft = scrollLeft > 0
      this.canScrollRight = scrollLeft < scrollWidth - clientWidth - 1
    }
  }

  scrollTabs(direction: "left" | "right") {
    if (!this.tabListRef?.nativeElement) return

    const tabElements = this.tabListRef.nativeElement.children
    if (tabElements.length === 0) return

    const tabWidth = (tabElements[0] as HTMLElement).offsetWidth
    const scrollAmount = tabWidth + 4 // tab width + gap

    const currentScrollLeft = this.tabListRef.nativeElement.scrollLeft
    const newScrollLeft = direction === "left" ? currentScrollLeft - scrollAmount : currentScrollLeft + scrollAmount

    this.tabListRef.nativeElement.scrollTo({
      left: newScrollLeft,
      behavior: "smooth",
    })
  }

  getRootFolderList(reSelected = true) {
    this.service.getFolderList({ isAdmin: false }).subscribe(result => {
      const { rtnData, rtnCode } = result;
      if (rtnCode === 10000) {
        this.nodes = rtnData;
        console.log(this.nodes);
        if (this.nodes.length && reSelected) {
          this.activeTopTab = this.nodes[0].id;
          this.params.parentId = this.nodes[0].id;
          this.currentPath = [{ id: this.nodes[0].id, name: this.nodes[0].name }]
          this.getList();
        }
      }
    });
  }

  transformNode(list: any) {
    return list.map((node: any) => ({
      key: node.id,
      title: node.name,
      id: node.id,
      parentId: node.parentId,
      isPublic: node.isPublic,
      customerList: node.customerList || [],
      isLeaf: !(node.children && node.children.length),
      children: this.transformNode(node.children),
    }));
  }

  onOpenUrl(url: string) {
    url && window.open(url);
  }
  constructor(private service: DocumentManagementService,
    private sanitizer: DomSanitizer, private message: NzMessageService,
    private translate: TranslateService, private urlValidatorService: UrlValidatorService,
    private sharedData: SharedDataService,
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
    this.checkScreenSize()
    window.addEventListener("resize", () => this.checkScreenSize())
  }

  ngOnInit() {
    this.checkScreenSize()
    window.addEventListener("resize", () => this.checkScreenSize())
    document.addEventListener("click", (event) => this.handleClickOutside(event))
    this.getRootFolderList();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768
  }

  handleClickOutside(event: Event) {
    if (this.dropdownRef && !this.dropdownRef.nativeElement.contains(event.target)) {
      this.hoveredFolder = null
      this.hoveredTab = ""
    }
  }

  handleTopTabClick(tabId: number, tabName: string) {
    this.activeTopTab = tabId
    this.params.parentId = tabId;
    this.currentPath = [{ id: tabId, name: tabName }]
    this.hoveredTab = ""
    this.pagination.pageIndex = 1;
    this.getList();
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_folder_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: tabName,
      });
    }
  }

  findPathById(nodes: any[], targetId: number): any[] {
    for (const node of nodes) {
      if (node.id === targetId) {
        return [{ id: node.id, name: node.name }];
      }
    
      if (node.children && node.children.length > 0) {
        const childPath = this.findPathById(node.children, targetId);
        if (childPath.length > 0) { // Check if array has elements, not just truthiness
          return [{ id: node.id, name: node.name }, ...childPath];
        }
      }
    }
    return [];
}

  handleFolderClick(folderId: number, folderName: string, event: MouseEvent) {
    this.currentPath = this.findPathById(this.nodes, folderId)
    this.activeTopTab = folderId
    this.hoveredFolder = null
    this.hoveredTab = ""
    event.stopPropagation()
    this.params.parentId = this.activeTopTab;
    this.onSearch()
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_folder_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: folderName,
      });
    }
  }


  getList() {
    const { title, content, parentId } = this.params;
    this.service.getTableList({
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      name: title,
      description: content,
      parentId,
      type: 'file',
      isAdmin: false
    }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000 && rtnData) {
        const { total, records } = rtnData;
        this.documents = records;
        this.documents.forEach(row => {
          if (row.fileName) {
            const fileType = row.fileName.split('.').pop()?.toUpperCase();
            row.fileType = fileType;
          }
          row.imageBase64 = row.imageBase64 ? this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + row.imageBase64) : '';
        });
        this.pagination.total = total;
      }
    });
  }

  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
  }

  pageIndexChange(pageIndex?: number) {
    if (pageIndex) {
      this.pagination.pageIndex = pageIndex;
      this.getList();
    }

  }

  onDownloadFile(url: string, name: string) {
    this.service.downloadFile(url).subscribe((result: any) => {
      if (result) {
        if (result.rtnCode && result.rtnCode !== 10000) {
          this.message.error(result.rtnMsg);
          return;
        }
        const url = window.URL.createObjectURL(
          new Blob([result], { type: result.type })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  handleBreadcrumbClick(index: number) {
    this.currentPath = this.currentPath.slice(0, index + 1)
    this.activeTopTab  = this.currentPath[this.currentPath.length-1].id
    this.params.parentId = this.activeTopTab;
    this.onSearch()
  }

  onMouseEnterTab(tabId: number | string, tabIndex: number) {
    // 看nodes里面对象id为tabId的对象的children的数组长度是否为0
    const tab = this.nodes.find(node => node.id === tabId)
    if (!tab) return
    const hasChildren = tab.children && tab.children.length > 0
    if (!this.isMobile && hasChildren) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }
      this.calculateDropdownPosition(tabIndex);
      this.hoveredTab = tabId
      console.log("Hover tab set to:", this.hoveredTab)
    }
  }

getHoveredTabChildren() {
  if (!this.hoveredTab) return [];
  const tab = this.nodes.find(node => node.id === this.hoveredTab);
  return tab?.children || [];
}
  private calculateDropdownPosition(tabIndex: number) {
    if (!this.tabListRef?.nativeElement) return;
    
    const container = this.tabListRef.nativeElement;
    const buttons = container.children;
    
    if (buttons[tabIndex]) {
      const button = buttons[tabIndex] as HTMLElement;
      const rect = button.getBoundingClientRect();
      
      this.dropdownPosition = {
        x: rect.left,
        y: rect.bottom + 4
      };
    }
  }
  scrollLeft() {
    if (this.tabListRef?.nativeElement) {
      this.tabListRef.nativeElement.scrollBy({ left: -200, behavior: 'smooth' });
    }
  }
  
  scrollRight() {
    if (this.tabListRef?.nativeElement) {
      this.tabListRef.nativeElement.scrollBy({ left: 200, behavior: 'smooth' });
    }
  }
  onMouseLeaveTab() {
    if (!this.isMobile) {
      this.hideTimeout = setTimeout(() => {
        this.hoveredTab = ""
        this.dropdownPosition = null;
      }, 150)
    }
  }
  onMouseEnterDropdown(tabId: number | string) {
    if (!this.isMobile) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }
      this.hoveredTab = tabId
      console.log("Dropdown hover tab set to:", this.hoveredTab)
    }
  }

  onMouseLeaveDropdown() {
    if (!this.isMobile) {
      this.hoveredTab = ""
      this.dropdownPosition = null;
    }
  }

  onMouseEnterFolder(folderId: string, hasChildren: boolean) {
    if (hasChildren && !this.isMobile) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }
      this.hoveredFolder = folderId
    }
  }

  onMouseLeaveFolder() {
    if (!this.isMobile) {
      this.hideTimeout = setTimeout(() => {
        this.hoveredFolder = null
      }, 150)
    }
  }

  onMouseEnterFolderDropdown(folderId: string) {
    if (!this.isMobile) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }
      this.hoveredFolder = folderId
    }
  }

  onMouseLeaveFolderDropdown() {
    if (!this.isMobile) {
      this.hoveredFolder = null
    }
  }


  onSearch() {
    this.pagination.pageIndex = 1;
    this.getList();
  }
}
